// @ts-nocheck
import {
  ADD_CHANGE_PASSWORD_FIELD_ERROR,
  ADD_CHANGE_PASSWORD_FIELDS_ERRORS,
  CHANGE_CHANGE_PASSWORD_FORM_FIELD,
  CLEAR_CHANGE_PASSWORD_FIELD_ERROR,
  RESET_CHANGE_PASSWORD_FORM_DATA,
} from './actions'

const defaultFormData = () => ({
  oldPassword: '',
  newPassword: '',
  confirmPassword: '',
})

export const initialState = () => ({
  data: defaultFormData(),
  errors: {},
})

export default function root(state = initialState(), action) {
  switch (action.type) {
    case CHANGE_CHANGE_PASSWORD_FORM_FIELD:
      return {
        ...state,
        data: {
          ...state.data,
          [action.payload.key]: action.payload.value,
        },
      }

    case ADD_CHANGE_PASSWORD_FIELD_ERROR:
      return {
        ...state,
        errors: {
          ...state.errors,
          [action.payload.field]: action.payload.error,
        },
      }

    case ADD_CHANGE_PASSWORD_FIELDS_ERRORS:
      return {
        ...state,
        errors: action.payload.errors,
      }

    case CLEAR_CHANGE_PASSWORD_FIELD_ERROR:
      return {
        ...state,
        errors: {
          ...state.errors,
          [action.payload.field]: undefined,
        },
      }

    case RESET_CHANGE_PASSWORD_FORM_DATA:
      return {
        ...state,
        data: defaultFormData(),
        errors: {},
      }

    default:
      return state
  }
}
